import React from 'react';

import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from '@material-ui/core';
import { StyledButton, StyledTypography } from 'styles/common';

export const CancelMeetingConfirmationModal = ({ onConfirm, onCancel, open }) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle style={{ paddingTop: '2rem' }} id="alert-dialog-title">
      Cancel meeting?
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        This meeting will be considered as not done. Are you sure you want to cancel this meeting?
      </DialogContentText>
    </DialogContent>
    <Box mx={50} my={20}>
      <Divider />
    </Box>
    <DialogActions>
      <StyledButton variant="outlined" onClick={onCancel} color="primary" bottomGutter={1} rightGutter={1}>
        <StyledTypography variant="body1" clickable>
          Go Back
        </StyledTypography>
      </StyledButton>
      <StyledButton
        variant="contained"
        onClick={() => {
          onConfirm();
          onCancel();
        }}
        color="primary"
        rightGutter={2}
        bottomGutter={1}
        autoFocus
      >
        <StyledTypography variant="body1" isClickable>
          Cancel this Meeting
        </StyledTypography>
      </StyledButton>
    </DialogActions>
  </Dialog>
);
